import React from "react";
import "../Director/Director.css";
import CoFounderImage from "../../../../../assets/ihn/team/co-founder.webp";
import Linkedin from "../../../../../assets/logo/linkedin.webp"
import TeamLead from "../Team-Lead/TeamLead";

const CoFounder = () => {
  return (
    //    <div className="page-content">
    // <section className="director-page">
    //   <div className="director-container">

    

    //      <div className="founder-image-wrapper">
    //                 <img src={CoFounderImage} alt="Poonam Singh" className="founder-main-image" />
    //                 <a
    //                   href="https://www.linkedin.com/in/punam-singh-a108ab63/"
    //                   target="_blank"
    //                   rel="noreferrer"
    //                   className="founder-linkedin-overlay"
    //                 >
    //                   <img src={Linkedin} className="founder-linkedin-icon" alt="LinkedIn" />
    //                 </a>
    //               </div>

    //     {/* RIGHT : SHORT CONTENT */}
    //     <div className="director-content">
    //       <h1 className="director-title">Co-Founder</h1>
    //       <h2 className="director-name">Poonam Singh</h2>


    //       <p>
    //         A seasoned industry veteran with over 30 years of mastery across the Travel, Hospitality, and Mentoring sectors. Punam serves as the strategic bridge between visionary concepts and operational excellence, consistently delivering solutions where others encounter complexity.
    //       </p>
    //       <p>
    //         Guided by the core philosophy of "empowering through leadership," she fosters a culture of responsiveness and authentic connection within the IHN team. Her mission is to cultivate a legacy of professional distinction while driving meaningful impact across the global hospitality landscape.
    //       </p>
    //     </div>

    //   </div>
    // </section>
    // </div>
     <div className="page-content">
 <TeamLead defaultTab="cofounder" />

     </div>
  );
};

export default CoFounder;